<template>
    <v-app id="searchPtenAgents">
        <!-- header -->
        <headerPtenAgent class="mt-16"/>
        <!-- table -->
        <tablePtenAgent ref="tablePtenAgent" @actionClick="actionClick" class="mt-0 px-3" />
        <!-- navBar -->
        <navbarPten menuIndex="0" @actionClick="actionClick" />
    </v-app>
</template>

<script>
    import headerPtenAgent from '@/components/pten/headerPtenAgent.vue';
    import tablePtenAgent from '@/components/pten/tablePtenAgent.vue';
    import navbarPten from '@/components/pten/navbarPten.vue';
    
    export default {
        components: {
            headerPtenAgent,
            tablePtenAgent,
            navbarPten,
        },
        data() {
            return {
            }
        },
        mounted() {
            document.title = "ARES - Leads";
        },
        methods: {
            actionClick(action) {
                switch (action) {
                    case "refresh":
                        this.$refs.tablePtenAgent.getPtenAgents();
                        break;
                    default:
                        break;
                }
            },
        }
    };
</script> 
